import { useEffect, useState } from "react";
import { Button as BButton, Modal, Spinner } from "react-bootstrap";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Grid, List, ListItemButton, ListItemIcon, ListItemText, Checkbox, Button, Paper } from "@mui/material";

import ApiSupplierAgents from "../../../core/api/api.supplierAgent";

function not(a, b) {
  // پیدا کردن غیر مشترکات دو آرایه از آبجکت ها بر اساس آیدی
  return _.differenceBy(a, b, "id");
}

function intersection(a, b) {
  // پیدا کردن مشترکات دو آرایه از آبجکت ها بر اساس آیدی
  return _.intersectionBy(a, b, "id");
}

export const AddSupplierToAgentModal = ({
  showAddSupplierToAgentModal,
  setShowAddSupplierToAgentModal,
  selectedUser,
  suppliers,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [checked, setChecked] = useState([]);
  const [left, setLeft] = useState([]);
  const [right, setRight] = useState([]);
  const [loading, setLoading] = useState(false);

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);


  const handleToggle = (value) => () => {
    // const currentIndex = checked.indexOf(value);
    const currentIndex = checked.find((item) => item.id === value.id);
    let newChecked = [...checked];
    if (currentIndex === undefined) {
      newChecked.push(value);
    } else {
      // newChecked.splice(currentIndex, 1);
      newChecked = newChecked.filter((item) => item.id !== value.id);
    }
    setChecked(newChecked);
  };

  const handleAllRight = () => {
    setRight(right.concat(left));
    setLeft([]);
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    // return
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const handleAllLeft = () => {
    setLeft(left.concat(right));
    setRight([]);
  };

  const handleClose = () => {
    setShowAddSupplierToAgentModal(false);
  };

  const customList = (items) => (
    <Paper sx={{ width: 200, height: 230, overflow: "auto" }}>
      <List dense component="div" role="list">
        {items.map((value) => {
          const labelId = `transfer-list-item-${value.id}-label`;
          return (
            <ListItemButton key={value.id} role="listitem" onClick={handleToggle(value)}>
              <ListItemIcon>
                <Checkbox
                  checked={_.some(checked, { id: value.id })}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{
                    "aria-labelledby": labelId,
                  }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={`${value.companyName}`} />
            </ListItemButton>
          );
        })}
      </List>
    </Paper>
  );

  useEffect(() => {
    const fetchAgentSuppliers = async () => {
      setLoading(true);
      try {
        const agentSuppliers = await ApiSupplierAgents.getAllSuppliersByAgentId({ agnetId: selectedUser });
        const fetchedSuppliers =
          agentSuppliers.data?.length !== 0 ? agentSuppliers.data.map((item) => ({ id: item.supplier.id })) : [];
        if (fetchedSuppliers.length !== 0) {
          const filteredSuppliers = _.differenceBy(suppliers, fetchedSuppliers, "id");
          const commonObjects = _.intersectionBy(suppliers, fetchedSuppliers, "id");
          setLeft([...commonObjects]);
          setRight([...filteredSuppliers]);
        } else {
          setRight([...suppliers]);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchAgentSuppliers();
  }, []);

  const onSubmit = async (e) => {
    try {
      e.preventDefault();
      setIsSubmitting(true);
      const selectedSupplierIds = left.map((item) => item.id);
      const dataToSendServer = {
        supplierIds: selectedSupplierIds,
        agentId: +selectedUser,
      };
      const response = await ApiSupplierAgents.createAndUpdateSupplierAgentByAgentId(dataToSendServer);
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      if (response.succeeded) handleClose();
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <Modal centered size="lg" show={showAddSupplierToAgentModal} onHide={handleClose}>
        <form id="form" onSubmit={onSubmit}>
          <Modal.Header closeButton>
            <Modal.Title> افزودن تامین کننده به نماینده </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {loading ? (
              <div className="d-flex justify-content-center align-items-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Grid container spacing={2} sx={{ justifyContent: "center", alignItems: "center", direction: "ltr" }}>
                <Grid item>
                  <p className="ml-6">تامین کننده های انتخابی</p>
                  {left?.length === 0 && <div className="mt-5 text-warning">تامین کننده ای انتخاب نشده است </div>}
                  {customList(left)}
                </Grid>
                <Grid item>
                  <Grid container direction="column" sx={{ alignItems: "center" }}>
                    <Button
                      sx={{ my: 0.5 }}
                      variant="outlined"
                      size="small"
                      onClick={handleAllRight}
                      disabled={left.length === 0}
                      aria-label="move all right"
                    >
                      ≫
                    </Button>
                    <Button
                      sx={{ my: 0.5 }}
                      variant="outlined"
                      size="small"
                      onClick={handleCheckedRight}
                      disabled={leftChecked.length === 0}
                      aria-label="move selected right"
                    >
                      &gt;
                    </Button>
                    <Button
                      sx={{ my: 0.5 }}
                      variant="outlined"
                      size="small"
                      onClick={handleCheckedLeft}
                      disabled={rightChecked.length === 0}
                      aria-label="move selected left"
                    >
                      &lt;
                    </Button>
                    <Button
                      sx={{ my: 0.5 }}
                      variant="outlined"
                      size="small"
                      onClick={handleAllLeft}
                      disabled={right.length === 0}
                      aria-label="move all left"
                    >
                      ≪
                    </Button>
                  </Grid>
                </Grid>
                <Grid item>
                  <p className="ml-6">همه تامین کننده ها</p>
                  {customList(right)}
                </Grid>
              </Grid>
            )}
          </Modal.Body>
          <Modal.Footer>
            <BButton variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ذخیره
            </BButton>
            <BButton variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </BButton>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
